import React, { useEffect, useState, useMemo, useContext } from 'react';
import { Grid, makeStyles, Box, Hidden, Avatar } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from '../../../utils/isEmpty';
import {
  // setActualReunion,
  updateReunion,
  updateProposalVotes,
  updateReunionPointInfo,
  updatePublicDiscussionTimer,
  updateBeforeDayOrderTimer,
  updatePointDiscussionTimer,
  updateMeetingTimer,
  addReunionPoint,
  addPointDiscussionTimer,
} from '../../../store/actions/reunionsActions';
import { useParams } from 'react-router-dom';
import { getConfig } from '../../../store/actions/configActions';
import { SocketReunion } from './SocketReunionWrapper';
import NoProposalPlateia from './pieces/activeMeeting/NoProposalPlateia';
import ParticipantUsersPlateia from './pieces/activeMeeting/ParticipantUsersPlateia';
import H2 from '../../common/typographys/H2';
import { MeetingCommon } from './MeetingCommonWrapper';
import useForceUpdate from '../../../utils/hooks/useForceUpdate';
import PlateiaTitleDescription from './plateia/PlateiaTitleDescription';
import PlateiaBeforeDayOrderItem from './plateia/PlateiaBeforeDayOrderItem';
import DiscussionOrVote from './plateia/DiscussionOrVote';
import SideXLVote from './plateia/SideXLVote';
import BottomVote from './plateia/BottomVote';
import AllProposalStatus from './plateia/AllProposalStatus';
import flatten from 'lodash/flatten';
import clsx from 'clsx';
import VotingUsersPlateia from './plateia/VotingUsersPlateia';
import PlateiaTimer from './plateia/PlateiaTimer';
import logo from '../../../assets/images/logo.png';
import H6 from '../../common/typographys/H6';
import H5 from '../../common/typographys/H5';

const useStyles = makeStyles(theme => ({
  marginContainers: {
    marginTop: '70px',
    width: '100%',
  },
  marginHeader: {
    marginBottom: '10px',
  },
  marginPlateia: {
    marginTop: '75px',
    width: '100%',
  },
  fullSize: {
    height: '100vh',
    width: '100%',
  },
  container: {
    margin: theme.spacing(0),
    flexGrow: 0,
    maxWidth: '100%',
    flexBasis: '100%',

    overflow: 'hidden',
  },
  timeContainer: {
    margin: theme.spacing(0),
    flexGrow: 0,
    maxWidth: '100%',
  },
  fullHeight: {
    height: '100vh',
  },
  drawer: {
    width: '100%',
    height: '100%',
    flexShrink: 0,
  },
  drawerPaper: {
    width: '100%',
    position: 'static',
    marginLeft: '12px',
    paddingTop: '12px',
    overflowX: 'hidden',
  },
  noPadding: {
    padding: '0px!important',
  },
  heightBox: {
    [theme.breakpoints.up('xl')]: {
      height: '50px',
    },
    [theme.breakpoints.down('lg')]: {
      height: '10px',
    },
  },
  bottomVote: {
    padding: '0px!important',
    marginTop: 'auto',
  },
  fullWidth: {
    width: '100%',
  },
  leftMenu: {
    overflow: 'hidden',
    [theme.breakpoints.up('xl')]: {
      maxHeight: '940px',
    },
    [theme.breakpoints.down('lg')]: {
      maxHeight: '540px',
    },
  },
  activeParticipantBox: {
    backgroundColor: theme.palette.neutrals[1],
    padding: '15px 30px 0',
  },
  logoBox: {
    padding: '0'
  },
  // logoImage: {
  //   width: 30,
  //   height: 30,
  //   objectFit: 'contain',
  // },
  logo: {
    marginLeft: 'auto',
    marginRight: 'auto',
    // [theme.breakpoints.down('xl')]: {
    //   height: '300px',
    //   width: '300px',
    // },
    height: '110px',
    width: '110px',
    // background: '#fff',
  },
  logoImg: {
    width: 'inherit',
    height: '100%',
    objectFit: 'contain',
    textAlign: 'center',
    // [theme.breakpoints.down('xl')]: {
    //   padding: '40px',
    // },
    padding: '10px',
  },
}));

const periods = [
  { type: 'public-discussion', name: 'Intervenção do público' },
  { type: 'before-day-order', name: 'Antes da ordem do dia' },
  // { type: 'day-order', name: 'Ordem do dia' },
];

const MeetingPlateia = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { id } = useParams();
  const { reunion } = useSelector(state => state.reunions);
  const {
    speakers,
    is_group,
    infoSpeaking,
    participants,
    is_public: isPublic,
    public_participants: publicParticipants,
    activePublicParticipant
  } = reunion;
  const [active, setActive] = useState({});
  const [activeInfo, setActiveInfo] = useState({});
  const [typeVote, setTypeVote] = useState('');
  const [voting, setVoting] = useState(false);
  const [votes, setVotes] = useState([]);
  const [secretVotes, setSecretVotes] = useState({ favor: 0, against: 0, abstention: 0, novote: 0 });
  const [activeParticipant, setActiveParticipant] = useState(null);
  const { socketNsp, email } = useContext(SocketReunion);
  const { reunionEnd, setReunionEnd } = useContext(MeetingCommon);
  const [forceUpdate] = useForceUpdate();
  const [, setAux] = useState('');

  useEffect(() => {
    dispatch(getConfig());
  }, [dispatch]);
  const publicDiscussionTimer = useSelector(
    state => state.reunions?.reunion?.timers?.publicDiscussion || {}
  );
  const beforeDayOrderTimer = useSelector(
    state => state.reunions?.reunion?.timers?.beforeDayOrder || {}
  );
  const discussionPointsTimers = useSelector(
    state => state.reunions?.reunion?.timers?.points || {}
  );
  const meetingTimer = useSelector(state => state.reunions?.reunion?.timers?.meeting || {});

  const activeParticipants = useMemo(() => participants.filter(x => x.checkIn), [participants]);

  const proposals = useMemo(() => {
    const flattenThemes = flatten(reunion.themes.map(theme => [...theme.points]));
    const allProposals = [...flattenThemes, ...reunion.points];

    return allProposals;
  }, [reunion.themes, reunion.points]);

  useEffect(() => {
    if (!isEmpty(reunion.activeInfo) && reunion.sentSocket) {
      setActiveInfo(reunion.activeInfo);
    }
  }, [reunion.sentSocket, reunion.activeInfo]);

  useEffect(() => {
    if (!isEmpty(activeInfo)) {
      const { idxProposal, idxTheme, type } = activeInfo;
      if (type === 'before-day-order-item') {
        // @ É uma moção/menção honrosa (antes da ordem do dia)
        const result = (reunion.before_day_order_items || [])[idxProposal] || {};
        setActive({ ...result, type });
      } else if (idxProposal !== null && idxTheme !== null) {
        // @ É uma proposta inserida num tema
        const result = reunion.themes[idxTheme].points[idxProposal] || null;
        setActive(result);
      } else if (idxProposal !== null && idxTheme === null) {
        // @ É uma proposa sem tema
        const result = reunion.points[idxProposal] || null;
        setActive(result);
      } else if (idxProposal === null && idxTheme !== null) {
        // @ Tema sem pontos
        const result = reunion.themes[idxTheme] || null;
        setActive(result);
      } else if (idxProposal === null && idxTheme === null) {
        // @ É um período
        const period = periods.find(x => x.type === type) || {};
        setActive(period);
      }
    }
  }, [activeInfo, reunion.themes, reunion.points, reunion.before_day_order_items]);

  useEffect(() => {
    const voteCanceledHandler = info => {
      const parsed = JSON.parse(info);
      setVoting(false);
      forceUpdate();
      setAux(parsed);
    };

    socketNsp.on('vote_canceled', voteCanceledHandler);

    return () => {
      socketNsp.off('vote_canceled', voteCanceledHandler);
    };
  }, [forceUpdate, socketNsp]);

  useEffect(() => {
    socketNsp.on('reunion_details', info => {
      dispatch(updateReunion(JSON.parse(info)));
    });

    socketNsp.on('reunion_speakers', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunion({ speakers: parsed }));
    });

    socketNsp.on('current_public_time', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunion({ currentPublic: parsed }));
    });

    socketNsp.on('reunion_info_speaking', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunion({ infoSpeaking: parsed }));
    });

    socketNsp.on('reunion_speakers_info', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunion({ speakersInfo: parsed }));
    });

    socketNsp.on('update_meeting_point_status', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunionPointInfo(parsed));
      setVoting(false);
      setActive(c => ({ ...c, meeting_point_status: parsed.meeting_point_status }));
    });

    socketNsp.on('update_votes', info => {
      const parsed = JSON.parse(info);
      setVotes(parsed);
    });

    socketNsp.on('update_secret_votes', info => {
      const parsed = JSON.parse(info);
      setSecretVotes(parsed);
    });

    socketNsp.on('update_active', info => {
      const parsedInfo = JSON.parse(info);
      setActiveInfo(parsedInfo);
    });

    socketNsp.on('start_vote', info => {
      const { type } = JSON.parse(info);
      setTypeVote(type);
      setVoting(true);
    });

    socketNsp.on('final_votes', info => {
      setVoting(false);
      dispatch(updateProposalVotes(JSON.parse(info)));
      setVotes([]);
    });

    socketNsp.on('vote', info => {
      const parsed = JSON.parse(info);
      const { userId: userIdVoted, groupId, vote } = parsed;

      if (typeVote === 'public') {
        setVotes(c => [
          ...c.filter(x => x.id.toString() !== userIdVoted.toString()),
          { id: userIdVoted, group_id: groupId, vote },
        ]);
      }
    });

    socketNsp.on('update_votes', info => {
      const parsed = JSON.parse(info);
      setVotes(parsed);
    });

    socketNsp.on('reunion_finished', () => {
      setReunionEnd(true);
    });

    socketNsp.on('meeting_point_added', info => {
      const { themeId, themeName, point, timerId, pointTimers } = JSON.parse(info);
      dispatch(addReunionPoint(themeId, themeName, point));
      dispatch(addPointDiscussionTimer(timerId, pointTimers));
    });

    socketNsp.on('reunion_speakers', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunion({ speakers: parsed }));
    });

    socketNsp.on('reunion_info_speaking', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunion({ infoSpeaking: parsed }));
    });

    socketNsp.on('reunion_speakers_info', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunion({ speakersInfo: parsed }));
    });

    socketNsp.on('update_meeting_point_status', info => {
      const parsed = JSON.parse(info);
      dispatch(updateReunionPointInfo(parsed));
      setActive(c => ({ ...c, meeting_point_status: parsed.meeting_point_status }));
    });

    socketNsp.on('list_presences', info => {
      dispatch(updateReunion(JSON.parse(info)));
    });

    socketNsp.on('public_discussion_timer_updated', updatedTimerPayload => {
      const timerState = JSON.parse(updatedTimerPayload).publicDiscussion;

      dispatch(updatePublicDiscussionTimer(timerState));
    });

    socketNsp.on('before_day_order_timer_updated', updatedTimerPayload => {
      const timerState = JSON.parse(updatedTimerPayload).beforeDayOrder;

      dispatch(updateBeforeDayOrderTimer(timerState));
    });

    socketNsp.on('point_discussion_timer_updated', updatedTimerPayload => {
      const { pointId, timerType, timerState } = JSON.parse(updatedTimerPayload);

      dispatch(updatePointDiscussionTimer(pointId, timerType, timerState));
    });

    socketNsp.on('meeting_timer_updated', updatedTimerPayload => {
      const timerState = JSON.parse(updatedTimerPayload).meeting;

      dispatch(updateMeetingTimer(timerState));
    });

    socketNsp.on('active_public_participant_update', info => {
      const parsed = JSON.parse(info);

      setActiveParticipant(parsed.participant);
    });

    socketNsp.emit('join', JSON.stringify({ id, email, plateia: true }));

    return () => {
      socketNsp.emit('leave', JSON.stringify({ id, email }));
      socketNsp.removeAllListeners();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activePublicParticipant) {
      setActiveParticipant(activePublicParticipant);
    }
  }, [activePublicParticipant]);

  useEffect(() => {
    if (active?.type !== 'public-discussion') setActiveParticipant(null);
  }, [active?.type]);

  const getActiveDiscussionPointTimerId = () =>
    active.proposal_id !== null ? `proposal-${active.id}` : `point-${active.id}`;

  const getActiveDiscussionPointTimer = type => {
    const timerId = getActiveDiscussionPointTimerId();

    return discussionPointsTimers[timerId][type];
  };

  const getTimerLabel = type => {
    const typologyPeriods = reunion?.typology?.periods;

    switch (type) {
      case 'public-discussion':
        return typologyPeriods?.publicDiscussion?.title || 'Intervenção do público';
      case 'before-day-order':
        return typologyPeriods?.beforeDayOrder?.title || 'Antes da ordem do dia';
      case 'presentation':
        return typologyPeriods?.presentation?.title || 'Apresentação da proposta';
      case 'protests':
        return typologyPeriods?.protests?.title || 'Protestos / defesa de honra / reações';
      default:
        return '';
    }
  };

  return !reunionEnd ? (
    <div className={classes.fullHeight}>
      {!!meetingTimer.state && (
        <Grid container spacing={3} alignItems="center" justify="center" className={classes.timeContainer}>

          <Grid item className={classes.logoBox}>
            <Box display="flex" alignItems="center" justifyContent="center">
              {/* <img src={logo} alt="Reunião logo" className={classes.logoImage} /> */}
              <Avatar
                src={logo}
                alt={process.env.REACT_APP_CLIENT_NAME}
                className={classes.logo}
                classes={{
                  img: classes.logoImg,
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm="auto">
            <PlateiaTimer
              timer={meetingTimer}
              inlineLabel
              label={`Duração da reunião de ${reunion?.date?.split(' ')[0]} - `}
            />
          </Grid>

        </Grid>
      )}
      <Grid container spacing={3} justify="center" className={classes.container}>
        {/* Proposta/período ativo em destaque no topo */}
        <Grid item xs={12}>
          <Box className={classes.heightBox} />
          {active.type === 'before-day-order-item' ? (
            <PlateiaBeforeDayOrderItem item={active} />
          ) : !isEmpty(active) ? (
            <PlateiaTitleDescription title={getTimerLabel(active.type) || active.name} />
          ) : (
            <NoProposalPlateia />
          )}
        </Grid>
        <Grid
          item
          xl={3}
          lg={4}
          md={5}
          className={clsx({ [classes.leftMenu]: voting })}
        >
          {/* <Box className={classes.heightBox} /> */}
          <Grid container justify="center" spacing={1}>
            <Grid item xs={12}>
              {!isEmpty(active) && active.type !== 'before-day-order-item' && (
                <>
                  {active.type === 'public-discussion' &&
                    reunion?.typology?.periods?.publicDiscussion?.enabled &&
                    reunion?.typology?.periods?.publicDiscussion?.time_enabled && (
                      <>
                        {isPublic && publicParticipants && publicParticipants.length > 0 && activeParticipant?.name && (
                          <Box className={classes.activeParticipantBox}>
                            {/* <Box height="20px" /> */}
                            <H6>Interveniente ativo</H6>
                            <H5>{activeParticipant?.name || 'Nenhum selecionado'}</H5>
                          </Box>
                        )}
                        <PlateiaTimer
                          timer={publicDiscussionTimer}
                          label="Tempo de fala do interveniente"
                        />
                      </>
                    )}
                  {active.type === 'before-day-order' &&
                    reunion?.typology?.periods?.beforeDayOrder?.enabled &&
                    reunion?.typology?.periods?.beforeDayOrder?.time_enabled && (
                      <PlateiaTimer
                        timer={beforeDayOrderTimer}
                        label="Tempo do período ativo"
                      />
                    )}
                  {active.type !== 'before-day-order' && active.type !== 'public-discussion' && (
                    <>
                      {reunion?.typology?.periods?.presentation?.enabled &&
                        reunion?.typology?.periods?.presentation?.time_enabled && (
                          <PlateiaTimer
                            timer={getActiveDiscussionPointTimer('presentation')}
                            // label="Período de apresentação da proposta"
                            label={`Período de ${reunion?.typology?.periods?.presentation?.title || 'Apresentação da proposta'}`}
                          />
                        )}
                      {reunion?.typology?.periods?.protests?.enabled &&
                        reunion?.typology?.periods?.protests?.time_enabled && (
                          <PlateiaTimer
                            timer={getActiveDiscussionPointTimer('protests')}
                            // label="Período de protestos / defesa de honra / reações"
                            label={`Período de ${reunion?.typology?.periods?.protests?.title || 'Protestos / defesa de honra / reações'}`}
                          />
                        )}
                    </>
                  )}
                  {/* <PlateiaTitleDescription title={active.name} description={active.description} /> */}
                  {/* <AllProposalStatus proposals={proposals} /> */}
                </>
              // ) : (
              //   <NoProposalPlateia />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xl={voting ? 7 : 9} lg={voting ? 6 : 8} md={7}>
          <DiscussionOrVote voting={voting} />
          <Box height="40px" />
          <Grid container spacing={2}>
            {!voting && speakers && speakers.length > 0 && (
              <ParticipantUsersPlateia
                users={speakers}
                participants={participants}
                isGroup={Boolean(is_group)}
                infoSpeaking={infoSpeaking}
              />
            )}
            {voting && activeParticipants && (
              <VotingUsersPlateia
                participants={activeParticipants}
                votes={votes}
                typeVote={typeVote}
                secretVotes={secretVotes}
                maxVotes={activeParticipants && activeParticipants.length}
              />
            )}
          </Grid>
        </Grid>
        {voting && typeVote !== 'secret' && (
          <>
            <Hidden lgDown>
              <Grid item xl={2} className={classes.noPadding}>
                <SideXLVote
                  votes={votes}
                  maxVotes={activeParticipants && activeParticipants.length}
                />
              </Grid>
            </Hidden>
            <Hidden only="xl">
              <Grid item xs={12} className={classes.bottomVote}>
                <BottomVote
                  votes={votes}
                  maxVotes={activeParticipants && activeParticipants.length}
                />
              </Grid>
            </Hidden>
          </>
        )}
      </Grid>
    </div>
  ) : (
    <Grid container justify="center" alignItems="center" className={classes.fullSize}>
      <H2>Reunião terminada. Obrigado pela sua atenção.</H2>
    </Grid>
  );
};

export default MeetingPlateia;
